import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { AuthRoutes, RouteParamsTypes, Modules, NonAuthRoutes } from '../enums';
import ProtectedRoute from '../components/ProtectedRoute';
import Dashboard from '../modules/home/dashboard/root';
import RenewalRadar from '../modules/home/renewal-radar';
import Reports from '../modules/home/reports';
import AuditLogViewer from '../modules/home/audit-log';
import SubscriptionList from '../modules/subscriptions/list';
import SubscriptionForm from '../modules/subscriptions/form';
import PaymentList from '../modules/payments/list';
import PaymentForm from '../modules/payments/form';
import FeatureFlagList from '../modules/feature-flags/list';
import FeatureFlagForm from '../modules/feature-flags/form';
import FeatureFlagDetail from '../modules/feature-flags/detail';
import OutboxLog from '../modules/notifications/outbox';
import DSARList from '../modules/compliance/dsar';

const Home: React.FC = () => {
  return (
    <Routes>
      <Route path={AuthRoutes.dashboard}>
        <Route
          path={AuthRoutes.dashboard + RouteParamsTypes.blank}
          element={<ProtectedRoute component={Dashboard} />}
        />
      </Route>
      <Route
        path={AuthRoutes.renewals + RouteParamsTypes.blank}
        element={<ProtectedRoute component={RenewalRadar} />}
      />
      <Route path={AuthRoutes.subscriptions}>
        <Route
          path={AuthRoutes.subscriptions + RouteParamsTypes.blank}
          element={<ProtectedRoute component={SubscriptionList} />}
        />
        <Route
          path={AuthRoutes.subscriptions + RouteParamsTypes.add}
          element={<ProtectedRoute component={SubscriptionForm} />}
        />
        <Route
          path={AuthRoutes.subscriptions + RouteParamsTypes.edit + RouteParamsTypes.id}
          element={<ProtectedRoute component={SubscriptionForm} />}
        />
      </Route>
      <Route path={AuthRoutes.payments}>
        <Route
          path={AuthRoutes.payments + RouteParamsTypes.blank}
          element={<ProtectedRoute component={PaymentList} />}
        />
        <Route
          path={AuthRoutes.payments + RouteParamsTypes.add}
          element={<ProtectedRoute component={PaymentForm} />}
        />
      </Route>
      <Route path={AuthRoutes.featureFlags}>
        <Route
          path={AuthRoutes.featureFlags + RouteParamsTypes.blank}
          element={<ProtectedRoute component={FeatureFlagList} />}
        />
        <Route
          path={AuthRoutes.featureFlags + RouteParamsTypes.add}
          element={<ProtectedRoute component={FeatureFlagForm} />}
        />
        <Route
          path={AuthRoutes.featureFlags + RouteParamsTypes.edit + RouteParamsTypes.id}
          element={<ProtectedRoute component={FeatureFlagForm} />}
        />
        <Route
          path={AuthRoutes.featureFlags + RouteParamsTypes.id}
          element={<ProtectedRoute component={FeatureFlagDetail} />}
        />
      </Route>
      <Route
        path={AuthRoutes.notificationsOutbox + RouteParamsTypes.blank}
        element={<ProtectedRoute component={OutboxLog} />}
      />
      <Route
        path={AuthRoutes.reports + RouteParamsTypes.blank}
        element={<ProtectedRoute component={Reports} />}
      />
      <Route
        path={AuthRoutes.auditLog + RouteParamsTypes.blank}
        element={<ProtectedRoute component={AuditLogViewer} />}
      />
      <Route
        path={AuthRoutes.dsar + RouteParamsTypes.blank}
        element={<ProtectedRoute component={DSARList} />}
      />
      <Route
        path={RouteParamsTypes.blank}
        element={<Navigate replace to={{ pathname: Modules.home + AuthRoutes.dashboard }} />}
      />
      <Route
        path={RouteParamsTypes.any}
        element={<Navigate replace to={{ pathname: Modules.error + NonAuthRoutes.notFound }} />}
      />
    </Routes>
  );
};

export default Home;
